module.exports = __webpack_public_path__ + "img/fauteuil-5.0eb212fc.jpg";